import { MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function WhatsAppButton({ label = "Chat Konsultan", message }) {
  const { settings } = useSite();
  const number = settings?.whatsapp || "6281234567890";
  const text = encodeURIComponent(message || "Assalamu'alaikum, saya ingin bertanya tentang program Haji/Umrah KBIHU Muhammadiyah Surabaya.");

  return (
    <a
      href={`https://wa.me/${number}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg transition-transform hover:scale-105 sm:bottom-6 sm:right-6"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden text-sm font-medium sm:inline">{label}</span>
    </a>
  );
}
